var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRepairs4RangesLogoCookerDarkGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "#repairs4ranges-logo-cooker") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #2e2e2e } \n\t\t.shp1 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "oven - Dark Grey"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path237",
    className: "shp0",
    d: "M52 47.33C52 47.76 51.65 48.1 51.23 48.1L13.77 48.1C13.35 48.1 13 47.76 13 47.33L13 16.52C13 16.1 13.35 15.75 13.77 15.75L51.23 15.75C51.65 15.75 52 16.1 52 16.52L52 47.33L52 47.33Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path241",
    fillRule: "evenodd",
    className: "shp1",
    d: "M16.9 44.88C16.73 44.88 16.57 44.81 16.45 44.7C16.33 44.58 16.26 44.42 16.26 44.25L16.26 23.74C16.26 23.57 16.33 23.41 16.45 23.29C16.56 23.17 16.73 23.1 16.9 23.1L48.1 23.1C48.26 23.1 48.43 23.17 48.55 23.29C48.67 23.41 48.74 23.57 48.74 23.74L48.74 44.25C48.74 44.41 48.67 44.58 48.55 44.7C48.43 44.81 48.26 44.88 48.1 44.88L16.9 44.88L16.9 44.88L16.9 44.88ZM48.09 44.25L48.09 43.62L48.09 44.25L48.09 44.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path243",
    className: "shp0",
    d: "M21.36 27.38C21.01 27.38 20.74 27.1 20.74 26.77C20.74 26.43 21.01 26.15 21.36 26.15L43.64 26.15C43.98 26.15 44.26 26.43 44.26 26.77C44.26 27.1 43.98 27.38 43.64 27.38L21.35 27.38L21.35 27.38L21.36 27.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path247",
    className: "shp0",
    d: "M47.82 50.77C47.82 51.2 47.47 51.54 47.05 51.54L44.41 51.54C43.99 51.54 43.64 51.2 43.64 50.77L43.64 49.56C43.64 49.14 43.99 48.79 44.41 48.79L47.05 48.79C47.47 48.79 47.82 49.14 47.82 49.56L47.82 50.78L47.82 50.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path249",
    className: "shp0",
    d: "M21.36 50.77C21.36 51.2 21.01 51.54 20.59 51.54L17.95 51.54C17.52 51.54 17.18 51.2 17.18 50.77L17.18 49.56C17.18 49.14 17.52 48.79 17.95 48.79L20.59 48.79C21.01 48.79 21.36 49.14 21.36 49.56L21.36 50.78L21.36 50.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path251",
    className: "shp0",
    d: "M51.49 14.75C51.77 14.92 51.73 15.06 51.4 15.06L13.59 15.06C13.27 15.06 13.23 14.93 13.52 14.77L16.14 13.29C16.42 13.13 16.93 13 17.25 13L48.09 13C48.42 13 48.92 13.14 49.19 13.32L51.49 14.75L51.49 14.75Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path255",
    className: "shp1",
    d: "M23.31 19.25C23.31 20.41 22.35 21.36 21.16 21.36C19.98 21.36 19.02 20.41 19.02 19.25C19.02 18.08 19.98 17.13 21.16 17.13C22.35 17.13 23.31 18.08 23.31 19.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path257",
    className: "shp1",
    d: "M28.7 19.25C28.7 20.41 27.74 21.36 26.56 21.36C25.38 21.36 24.42 20.41 24.42 19.25C24.42 18.08 25.38 17.13 26.56 17.13C27.74 17.13 28.7 18.08 28.7 19.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path259",
    className: "shp1",
    d: "M40.58 19.25C40.58 20.41 39.62 21.36 38.43 21.36C37.25 21.36 36.29 20.41 36.29 19.25C36.29 18.08 37.25 17.13 38.43 17.13C39.62 17.13 40.57 18.08 40.57 19.25L40.58 19.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path261",
    className: "shp1",
    d: "M45.97 19.25C45.97 20.41 45.01 21.36 43.83 21.36C42.65 21.36 41.69 20.41 41.69 19.25C41.69 18.08 42.65 17.13 43.83 17.13C45.01 17.13 45.97 18.08 45.97 19.25L45.97 19.25Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepairs4RangesLogoCookerDarkGrey);
export default __webpack_public_path__ + "static/media/repairs4ranges-logo-cooker-dark-grey.18adaec69b80c90f9a0077dac85207e2.svg";
export { ForwardRef as ReactComponent };